React = require 'react'
Auth = require 'db/auth'
Controller = require 'controller'
Storage = require 'lib/storage'
t = require('views/internal/recup-with-helpers')()
{ FeedbackLink } = require './presentational/feedback-link'
StickyBoxWaitForMount = require 'views/lib/sticky-box-wait-for-mount'
HomeLeftSidebarContainer = require 'views/home/home-left-sidebar-container'
HomeMainContentContainer = require 'views/home/home-main-content-container'
HomeRightSidebarContainer = require 'views/home/home-right-sidebar-container'

module.exports = class HomeContainer extends React.Component
  displayName: 'HomeContainer'

  constructor: (props) ->
    super props
    @state = {
      sticky: false
    }

  componentWillReceiveProps: (nextProps) ->
    { modelCache, orgname } = nextProps

    if orgname
      orgs = modelCache.get('Member', Auth.myId())?.getSortedOrgs()
      if (!orgs.find((org) => org.get('name') == orgname))
        Storage.set("home_#{Auth.myId()}_last_tab_2", '/')
        Controller.navigate('/', { trigger: true })

  render: t.renderable ->
    { modelCache, model, orgname, allBoards, setFocusedCard } = @props

    { sticky } = @state

    t.div '.home-container', =>
      t.createElement FeedbackLink, {
        idMember: Auth.me().id
        isFloating: true
      }
      t.div '.sticky-spacer', =>
        t.div '.home-sticky-container', =>
          t.tag StickyBoxWaitForMount, {
            className: 'sticky-spacer'
          }, =>
            t.tag HomeLeftSidebarContainer, {
              modelCache
              model
              orgname
              allBoards
            }
          if !allBoards
            t.div '.sticky-spacer', =>
              t.tag HomeMainContentContainer, {
                modelCache
                orgname
                setFocusedCard
              }
            t.tag StickyBoxWaitForMount, {
              className: 'sticky-spacer'
            }, =>
              t.tag HomeRightSidebarContainer, {
                modelCache
                model
                orgname
              }
          else
            t.div '.all-boards', ->
              t.tag StickyBoxWaitForMount, {
                className: 'sticky-spacer'
              }, =>
                t.div '.content-all-boards', =>
                  allBoards()



// WEBPACK FOOTER //
// ./app/scripts/views/home/home-container.coffee